<div *ngIf="mfaConfigureProcess">
  <!--  <div class='row' [hidden]='otpVerified || pinVerified || forgotPin || newPinVerified'>-->
  <!--    <div class='mb-2 col-md-6 col-12'>-->
  <!--    <label>Please select MFA type</label>-->
  <!--      <kendo-dropdownlist-->
  <!--        [data]='mfaTypes'-->
  <!--        [formControl]='mfaTypeController'-->
  <!--      >-->
  <!--      </kendo-dropdownlist>-->
  <!--      <errors [on]='mfaTypeController.touched && mfaTypeController.invalid'>Required</errors>-->
  <!--    </div>-->
  <!--  </div>-->
  <div class="row" *ngIf="mfaTypeController.value">
    <div
      class="{{ forgotPin || (!newPinVerified && !currentUser?.isPinAvailable) ? '' : 'col-md-6' }} col-12"
      *ngIf="mfaTypeController.value === 'PIN'"
    >
      <div *ngIf="currentUser?.isPinAvailable">
        <p [hidden]="pinVerified || forgotPin">
          {{
            translate.currentLang === 'en'
              ? 'You already have PIN for your
          account. You can configure this PIN as MFA.'
              : 'আপনার অ্যাকাউন্টে ইতিমধ্যে PIN আছে। আপনি এই PIN কে MFA হিসাবে
          কনফিগার করতে পারেন।'
          }}
        </p>
        <form
          *ngIf="mfaConfigForm && !forgotPin && !pinVerified"
          class="form digit-group"
          #form="ngForm"
          [formGroup]="mfaConfigForm"
          (ngSubmit)="configMfa(form)"
          novalidate
        >
          <label>{{ translate.currentLang === 'en' ? 'Enter your PIN to verify' : 'যাচাই করার জন্য আপনার PIN লিখুন' }}</label>
          <div formGroupName="code" class="form-group">
            <input
              #mfaConfigPin1Row
              formControlName="pin1"
              autocomplete="new-password"
              name="pin1"
              type="text"
              pattern="[0-9]*"
              tabindex="1"
              maxlength="1"
              (keyup)="keyUpEvent($event, 0)"
            />
            <input
              #mfaConfigPin2Row
              formControlName="pin2"
              autocomplete="off"
              name="pin2"
              type="text"
              pattern="[0-9]*"
              tabindex="2"
              maxlength="1"
              (keyup)="keyUpEvent($event, 1)"
            />
            <input
              #mfaConfigPin3Row
              formControlName="pin3"
              autocomplete="off"
              name="pin3"
              type="text"
              pattern="[0-9]*"
              tabindex="3"
              maxlength="1"
              (keyup)="keyUpEvent($event, 2)"
            />
            <input
              #mfaConfigPin4Row
              formControlName="pin4"
              autocomplete="off"
              name="pin4"
              type="text"
              pattern="[0-9]*"
              tabindex="4"
              maxlength="1"
              (keyup)="keyUpEvent($event, 3)"
            />
            <input
              #mfaConfigPin5Row
              formControlName="pin5"
              autocomplete="off"
              name="pin5"
              type="text"
              pattern="[0-9]*"
              tabindex="5"
              maxlength="1"
              (keyup)="keyUpEvent($event, 4)"
            />
            <input
              #mfaConfigPin6Row
              formControlName="pin6"
              autocomplete="off"
              name="pin6"
              type="text"
              pattern="[0-9]*"
              tabindex="6"
              maxlength="1"
              (keyup)="keyUpEvent($event, 5)"
            />
            <div class="m-auto">
              <errors
                [on]="
                  ((mfaConfigForm.get('code').get('pin1').touched || form.submitted) && mfaConfigForm.get('code').get('pin1').invalid) ||
                  ((mfaConfigForm.get('code').get('pin2').touched || form.submitted) && mfaConfigForm.get('code').get('pin2').invalid) ||
                  ((mfaConfigForm.get('code').get('pin3').touched || form.submitted) && mfaConfigForm.get('code').get('pin3').invalid) ||
                  ((mfaConfigForm.get('code').get('pin4').touched || form.submitted) && mfaConfigForm.get('code').get('pin4').invalid) ||
                  ((mfaConfigForm.get('code').get('pin5').touched || form.submitted) && mfaConfigForm.get('code').get('pin5').invalid) ||
                  ((mfaConfigForm.get('code').get('pin6').touched || form.submitted) && mfaConfigForm.get('code').get('pin6').invalid)
                "
              >
                {{ translate.currentLang === 'en' ? 'Required' : 'আবশ্যক' }}
              </errors>
            </div>
          </div>
          <div [hidden]="!verifyMfaTypeErrors">
            <errors [on]="verifyMfaTypeErrors"> {{ verifyMfaTypeErrors }} </errors>
          </div>
          <button
            [disabled]="resendingVerificationCodes"
            class="form-btn full-w pink w-button ws-loading {{ verifyMfaType ? 'ws-loading-progress' : '' }}"
            type="submit"
          >
            {{ translate.currentLang === 'en' ? 'Verify' : 'যাচাই করুন' }}
          </button>
          <div class="mt-2 text-center">
            <div [hidden]="verifyMfaType" (click)="forgotPinView('PIN')" class="forgot-last-box mt-3">
              {{ translate.currentLang === 'en' ? 'Forgot PIN?' : 'PIN ভুলে গেছেন?' }}
            </div>
          </div>
        </form>
        <!--        <div *ngIf='pinVerified'>-->
        <!--          <p>PIN verification Succeed!</p>-->
        <!--          <p>Lets configure PIN as MFA</p>-->
        <!--          <button (click)="configMfaType('PIN')" class="form-btn full-w pink w-button ws-loading {{ configuringMfaType ? 'ws-loading-progress' : '' }}">Configure</button>-->
        <!--        </div>-->
      </div>
      <app-set-pin
        *ngIf="forgotPin"
        [mfa]="true"
        (forgotPinStatus)="forgetPinFromSetPin()"
        (newPinEnterScreen)="newPinEnterScreenDone($event)"
      ></app-set-pin>
      <div *ngIf="!currentUser?.isPinAvailable">
        <app-set-pin *ngIf="!newPinVerified" [mfa]="true" [currentUser]="currentUser" (forgotPinStatus)="newPinAdded()"> </app-set-pin>
        <!--        <div *ngIf='newPinVerified'>-->
        <!--          <p>PIN verification Succeed!</p>-->
        <!--          <p>Lets configure PIN verification as MFA</p>-->
        <!--          <button (click)="configMfaType('PIN')" class="form-btn full-w pink w-button ws-loading {{ configuringMfaType ? 'ws-loading-progress' : '' }}">Configure</button>-->
        <!--        </div>-->
      </div>
    </div>

    <div class="col-md-6 col-12" *ngIf="mfaTypeController.value === 'OTP'">
      <form
        *ngIf="mfaConfigForm && !otpVerified"
        class="form digit-group otp-form"
        #form="ngForm"
        [formGroup]="mfaConfigForm"
        (ngSubmit)="configMfa(form)"
        novalidate
      >
        <div class="mt-2">
          <label class="form--label">{{
            translate.currentLang === 'en'
              ? 'Enter your OTP code below to verify'
              : 'যাচাই
            করার জন্য নীচে আপনার OTP কোড লিখুন'
          }}</label>
          <p>
            {{
              translate.currentLang === 'en'
                ? 'We have sent you OTP via SMS and Email'
                : 'আমরা আপনাকে SMS এবং ইমেইলের
            মাধ্যমে OTP পাঠিয়েছি'
            }}
          </p>
          <div formGroupName="code" class="form-group">
            <input
              #mfaConfigOtp1Row
              formControlName="pin1"
              autocomplete="new-password"
              name="pin1"
              type="text"
              pattern="[0-9]*"
              tabindex="1"
              maxlength="1"
              (keyup)="keyUpEvent($event, 0)"
            />
            <input
              #mfaConfigOtp2Row
              formControlName="pin2"
              autocomplete="off"
              name="pin2"
              type="text"
              pattern="[0-9]*"
              tabindex="2"
              maxlength="1"
              (keyup)="keyUpEvent($event, 1)"
            />
            <input
              #mfaConfigOtp3Row
              formControlName="pin3"
              autocomplete="off"
              name="pin3"
              type="text"
              pattern="[0-9]*"
              tabindex="3"
              maxlength="1"
              (keyup)="keyUpEvent($event, 2)"
            />
            <input
              #mfaConfigOtp4Row
              formControlName="pin4"
              autocomplete="off"
              name="pin4"
              type="text"
              pattern="[0-9]*"
              tabindex="4"
              maxlength="1"
              (keyup)="keyUpEvent($event, 3)"
            />
            <div class="m-auto">
              <errors
                [on]="
                  ((mfaConfigForm.get('code').get('pin1').touched || form.submitted) && mfaConfigForm.get('code').get('pin1').invalid) ||
                  ((mfaConfigForm.get('code').get('pin2').touched || form.submitted) && mfaConfigForm.get('code').get('pin2').invalid) ||
                  ((mfaConfigForm.get('code').get('pin3').touched || form.submitted) && mfaConfigForm.get('code').get('pin3').invalid) ||
                  ((mfaConfigForm.get('code').get('pin4').touched || form.submitted) && mfaConfigForm.get('code').get('pin4').invalid)
                "
              >
                {{ translate.currentLang === 'en' ? 'Required' : 'আবশ্যক' }}
              </errors>
            </div>
          </div>
        </div>
        <div [hidden]="!verifyMfaTypeErrors">
          <errors [on]="verifyMfaTypeErrors"> {{ verifyMfaTypeErrors }} </errors>
        </div>

        <app-account-button
          [text]="translate.currentLang === 'en' ? 'Verify' : 'যাচাই করুন'"
          [disabled]="resendingVerificationCodes"
          [loading]="verifyMfaType"
          [type]="'primary'"
          type="submit"
        >
        </app-account-button>
      </form>
      <!--      <div *ngIf='otpVerified'>-->
      <!--        <p>OTP verification Succeed!</p>-->

      <!--        <p>Lets configure OTP verification as MFA</p>-->
      <!--        <button (click)="configMfaType('OTP')" class="form-btn full-w pink w-button ws-loading {{ configuringMfaType ? 'ws-loading-progress' : '' }}">Configure</button>-->
      <!--      </div>-->
    </div>
  </div>
</div>

<!--<div *ngIf='currentUser.mfaType && !mfaConfigureProcess && !mfaConfigured'>-->
<!--  <p>You have configured {{currentUser.mfaType}} as Multi-Factor Authentication (MFA). Do you need to change it to another type?</p>-->
<!--  <button class="form-btn pink w-button ws-loading" (click)='changeMfaType(currentUser.mfaType)'>Change</button>-->
<!--</div>-->

<div class="" *ngIf="mfaConfigured">
  <!--  Multi-Factor Authentication (MFA) successfully configured to you account. Please log in to you account again! thank you.-->
  {{
    translate.currentLang === 'en'
      ? 'PIN configuration successfully completed. Please use your PIN to verify MFA.'
      : 'PIN কনফিগারেশন সফলভাবে সম্পন্ন হয়েছে। অনুগ্রহ করে MFA যাচাই করতে আপনার PIN ব্যবহার করুন।'
  }}
</div>
